(function(window, angular){'use strict';

var ngModule = angular.module('pp.controllers.password-reset', ['pp.services.core', 'pp.services.investor', 'pp.components.password-validation']);

/**
 * controller for the password form
 */
ngModule.controller('passwordResetCtrl', ['$scope', '$timeout', 'ppTrack', 'investorService', function ($scope, $timeout, ppTrack, investorService) {
    var vm = this;

    // -- initial state

    // -- api

    // prevents form submission if there are errors
    vm.submit = function ($event) {
        $('#passwordResetError').remove();
        if (!vm.form.$valid) {
            vm.feedbackEnabled = true;
            $event.preventDefault();
        }
    };

    // -- scope bindings

    // -- main

    // legacy
    $timeout(function () {
        vm.ready = true;
    });

    investorService.getInvestor().then(function (user) {
        ppTrack.pageLoad('auth.password.reset');
    });
}]);
})(window, window.angular);